export default class {
  createArray(startFreq, stopFreq, pointsPerDecade) {
    var multiplier = Math.pow(10, 1 / pointsPerDecade);

    var i = 0;
    var result = [];
    result.push(startFreq);
    do {
      result[i + 1] = result[i] * multiplier;
      i++;
    } while (result[i] < stopFreq);

    return result;
  }
}
